import MemberDetails from "../../pages/reports/memberDetails";

export const reportMenus = [
    {
        menuCode: 'R-MD',
        menuComponent: <MemberDetails />
    },
];
    